import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgOutlinedInformation = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <circle cx={12} cy={12} r={10.5} stroke="currentColor" />
      <path
        fill="#3C3E41"
        fillRule="evenodd"
        d="M10.819 6.818a1.41 1.41 0 00-.098.525c0 .19.032.366.098.529.065.162.156.303.271.424a1.237 1.237 0 00.911.381 1.267 1.267 0 00.912-.381c.115-.12.205-.262.27-.424a1.4 1.4 0 00.1-.53 1.4 1.4 0 00-.1-.524 1.282 1.282 0 00-.68-.713A1.223 1.223 0 0012.002 6a1.21 1.21 0 00-.506.105 1.293 1.293 0 00-.676.713zM11.6 10a.6.6 0 00-.6.6v6.8a.6.6 0 00.6.6h.8a.6.6 0 00.6-.6v-6.8a.6.6 0 00-.6-.6h-.8z"
        className="OutlinedInformation_svg__OutlinedInformation_svg__symbol"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgOutlinedInformation.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgOutlinedInformation;
